import AgreementBox from './agreement-box.jsx';
export default AgreementBox;
